import React from "react";
import { Loading } from "../../App";

class Logout extends React.Component {
  componentDidMount() {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    window.location.assign("/");
  }

  render() {
    return (
      <div className="full-page">
        <Loading />
      </div>
    );
  }
}

export default Logout;
